// extracted by mini-css-extract-plugin
export var controls = "carouselControlsPic-module--controls--Jjd-u";
export var icon = "carouselControlsPic-module--icon--Uyh0O";
export var inactive = "carouselControlsPic-module--inactive--v65hn";